import { render, staticRenderFns } from "./QuasiContract.vue?vue&type=template&id=5f6cab72&scoped=true&"
import script from "./QuasiContract.vue?vue&type=script&lang=js&"
export * from "./QuasiContract.vue?vue&type=script&lang=js&"
import style0 from "./QuasiContract.vue?vue&type=style&index=0&id=5f6cab72&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6cab72",
  null
  
)

export default component.exports